import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { SabisNgxDialogService } from 'sabis-components2';

@Injectable({
  providedIn: 'root'
})
export class AppNavigationService {

  constructor(private _router: Router, private _dialog: SabisNgxDialogService) { }


  public goToGuideDetails(pageId: number): void {
    this._router.navigate(['pages', 'guide', 'list', pageId]);
  }
  public goToInfoDetails(pageId: number): void {
    this._router.navigate(['pages', 'info', 'list', pageId]);
  }

  public goToContinentsList(): void {
    this._router.navigate(['settings', 'continents']);
  }

  public goToEditJobRequisition(jobRequisitionId: number): void {
    this._router.navigate(['job-requisitions', jobRequisitionId]);
  }
  public goToJobRequisitionsList(isMyRequisitions?: boolean, isLiveRequisitions?: boolean, isExpiredRequisitions?: boolean, isPendingApprovalRequisitions?: boolean, isClosedRequisitions?: boolean, isDraftRequisitions?: boolean, isExpiringRequisitions?: boolean): void {
    this._router.navigate(['job-requisitions', 'list'], {
      queryParams: {
        'myRequisitions': isMyRequisitions,
        'liveRequisitions': isLiveRequisitions,
        'expiredRequisitions': isExpiredRequisitions,
        'pendingApprovalRequisitions': isPendingApprovalRequisitions,
        'closedRequisitions': isClosedRequisitions,
        'draftRequisitions': isDraftRequisitions,
        'expiringRequisitions': isExpiringRequisitions
      }
    });
  }
  public getJobRequisitionIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['jobRequisitionId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }
  public isMyRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['myRequisitions'];
    return value === 'true';
  }
  public isLiveRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['liveRequisitions'];
    return value === 'true';
  }
  public isExpiredRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['expiredRequisitions'];
    return value === 'true';
  }
  public isPendingApprovalRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['pendingApprovalRequisitions'];
    return value === 'true';
  }
  public isClosedRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['closedRequisitions'];
    return value === 'true';
  }
  public isExpiringRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['expiringRequisitions'];
    return value === 'true';
  }



  /**
   * Navigate to Job Vacancy form with param
   * @param hiringRequestId
   */
  public goToEditHiringRequest(hiringRequestId: number): void {
    this._router.navigate(['hiring-requests', hiringRequestId]);
  }
  /**Navigate to list of job vacancies */
  public goToHiringRequestsList(): void {
    this._router.navigate(['hiring-requests', 'list']);
  }

  /**
   * get job vacancy id from url
   * @param route
   * @returns
   */
  public getHiringRequestIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['hiringRequestId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToEditJobDescription(jobDescriptionId: number): void {
    this._router.navigate(['settings', 'job-descriptions', jobDescriptionId]);
  }
  public getJobDescriptionIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['jobPositionId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToCreateJobDescription(): void {
    this._router.navigate(['settings', 'job-descriptions', 'new']);
  }
  public goToJobDescriptionList(): void {
    this._router.navigate(['settings', 'job-descriptions', 'list']);
  }

  public goToAddUser(): void {
    this._router.navigate(['settings', 'users', 'new']);
  }
  public goToEditUser(userId: number): void {
    this._router.navigate(['settings', 'users', userId]);
  }
  public goToUsersList(): void {
    this._router.navigate(['settings', 'users', 'list']);
  }
  public getUserIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['userId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToAccessDenied(): void {
    this._router.navigate(['access-denied']);
  }

  public goToAddWorkflow(): void {
    this._router.navigate(['settings', 'workflows', 'new']);
  }
  public goToEditWorkflow(hiringRequestWorkflowId: number): void {
    this._router.navigate(['settings', 'workflows', hiringRequestWorkflowId]);
  }
  public goToWorkflowsList(): void {
    this._router.navigate(['settings', 'workflows', 'list']);
  }
  public getWorkflowIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['hiringRequestWorkflowId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToAddFeedbackFormTemplate(): void {
    this._router.navigate(['settings', 'feedback-forms', 'templates', 'new'], {
      queryParams: {
        'template-type': 'feedback'
      }
    });
  }
  public goToViewFeedbackFormTemplate(templateId: number): void {
    this._router.navigate(['settings', 'feedback-forms', 'templates', templateId], {
      queryParams: {
        'template-type': 'feedback'
      }
    });
  }
  public goToFeedbackFormTemplatesList(): void {
    this._router.navigate(['settings', 'feedback-forms', 'templates']);
  }
  public getTemplateId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['templateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToAddApplicationFormTemplate(): void {
    this._router.navigate(['settings', 'application-forms', 'templates', 'new'], {
      queryParams: {
        'template-type': 'application'
      }
    });
  }
  public goToViewApplicationFormTemplate(templateId: number): void {
    this._router.navigate(['settings', 'application-forms', 'templates', templateId], {
      queryParams: {
        'template-type': 'application'
      }
    });
  }
  public goToApplicationFormTemplatesList(): void {
    this._router.navigate(['settings', 'application-forms', 'templates']);
  }
  public getApplicationTemplateId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['templateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public getFormInstanceId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['instanceId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public getTemplateType(route: ActivatedRoute): 'feedback' | 'application' | null {
    let realValue = route.snapshot.queryParams['template-type'];
    if (!!realValue) {
      return realValue;
    }

    return null;
  }

  /**
   * Redirect to requisition candidates list
   * @param jobRequisitionId Job requisition id
   * @param applicationStatusIds Application status ids to filter the candidates list
   * @param isForGeneralApplications
   * @param countryId
   */
  public goToCandidatesList(jobRequisitionId: number | null, applicationStatusIds: number[], isForGeneralApplications: boolean, countryId: number | null): void {
    var queryParams = !!jobRequisitionId || isForGeneralApplications || countryId ? {
      'jrId': jobRequisitionId,
      'sIds': applicationStatusIds.length > 0 ? applicationStatusIds.join() : null, // application status ids filter
      'isGeneral': isForGeneralApplications,
      'cId': countryId
    } : null;

    this._router.navigate(['candidates', 'filtered'], {
      queryParams: queryParams
    });
  }

  public getJobRequisitionIdCandidateFilter(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.queryParams['jrId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }
  public goToCandidateProfile(candidateId: number): void {
    this._router.navigate(['candidates', candidateId]);
  }

  /**
   * Redirect to candidate profile with current requisition set to active
   * @param jobRequisitionId Job requisition id
   */
  public goToCandidateProfileWithActiveRequisition(candidateId: number, jobRequisitionId: number): void {
    this._router.navigate(['candidates', candidateId], {
      queryParams: {
        'jrId': jobRequisitionId
      }
    });
  }

  public getCandidateId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['candidateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  // email
  public goToFailedEmails(): void {
    this._router.navigate(['emails', 'failed', 'list']);
  }
  public goToPreviewEmail(emailId: number): void {
    this._router.navigate(['emails', emailId]);
  }
  public getEmailId(route: ActivatedRoute): number {
    let realValue = route.snapshot.params['emailId'];

    return +realValue;
  }

  // email templates
  public goToAddEmailTemplate(): void {
    this._router.navigate(['settings', 'email-templates', 'new']);
  }
  public goToEditEmailTemplate(emailTemplateId: number): void {
    this._router.navigate(['settings', 'email-templates', emailTemplateId]);
  }
  public goToEmailTemplatesList(): void {
    this._router.navigate(['settings', 'email-templates', 'list']);
  }
  public getEmailTemplateIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['emailTemplateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToRecruitmentStepsList(): void {
    this._router.navigate(['settings', 'recruitment-steps', 'list']);
  }




  // reports
  public goToReportEditor(reportId: number): void {
    this._router.navigate(['reports', reportId, 'editor']);
  }

  // reports list
  public goToReportsList(): void {
    this._router.navigate(['reports', 'list']);
  }

  public getReportId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['reportId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  // documents
  public goToCandidateDocuments(candidateId: number): void {
    this._router.navigate(['candidates', candidateId, 'documents']);
  }

  // application review
  public goToApplicationReview(candidateId: number, applicationId: number): void {
    this._router.navigate(['candidates', candidateId], {
      queryParams: {
        'applicationId': applicationId
      }
    });
  }
  public getApplicationId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.queryParams['applicationId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }



  public getReferenceCheckPublicId(route: ActivatedRoute): string {
    let realValue = route.snapshot.queryParams['pid'];

    return realValue;
  }

  public goToMyGeneralApplications(countryId: number): void {
    this.goToCandidatesList(null, [], true, countryId);
  }

  public goToGeneralApplications(): void {
    this._router.navigate(['dashboard/general-applications']);
  }

  public goToListOfValuesOptions(listOfValuesId: number): void {
    this._router.navigate(['settings', 'list-of-values', listOfValuesId, 'details']);
  }

  public goToHearAboutSabisValues(hearAboutSabisCategoryId: number): void {
    this._router.navigate(['settings', 'hear-about-sabis', 'categories', hearAboutSabisCategoryId, 'items']);
  }

  public goToCreateJobRequisition(): void {
    this._router.navigate(['job-requisitions', 'new']);
  }

  public goToCreateContractType(): void {
    this._router.navigate(['settings', 'contract-types', 'new']);
  }

  public goToEditContractType(contractTypeId: number): void {
    this._router.navigate(['settings', 'contract-types', contractTypeId]);
  }

  public getContractTypeIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['contractTypeId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToContractTypeList(): void {
    this._router.navigate(['settings', 'contract-types', 'list']);
  }
}
